import { SET_UP_ERRORS, ERROR_CODES } from 'state/error'
import i18n from 'config/i18n'

export const ERROR_MESSAGES: Record<string, Record<string, string>> = {
    [SET_UP_ERRORS.TITLE]: {
        [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterCampaignName'),
    },
    [SET_UP_ERRORS.BRAND]: {
        [ERROR_CODES.BRAND_INVALID_COUNTRY]: i18n.t('errorMessage.validation.selectBrandSameCountry'),
        [ERROR_CODES.BRAND_IMAGE_NOT_FOUND]: i18n.t(
            'campaignEditor.setUpCampaign.enterBrandNameSubheader.errorMessage.missingBrandImage',
        ),
        [ERROR_CODES.BRAND_DESCRIPTION_REQUIRED]: i18n.t(
            'campaignEditor.setUpCampaign.enterBrandNameSubheader.errorMessage.missingBrandImage',
        ),
    },
    [SET_UP_ERRORS.BUDGET]: {
        [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterCampaignBudget'),
    },
    [SET_UP_ERRORS.CATEGORIES]: {
        [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.selectCampaignCategory'),
    },
    [SET_UP_ERRORS.OBJECTIVE]: {
        [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.selectCampaignGoal'),
    },
    [SET_UP_ERRORS.SUBMISSION_STATUS_FILLING_FAST_MIN]: {
        [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterNumberSlots'),
        [ERROR_CODES.SUBMISSION_STATUS_FILLING_FAST_MIN_INVALID]: i18n.t('errorMessage.validation.enterNumberSlots'),
        [ERROR_CODES.SUBMISSION_STATUS_FULL_MIN_LOWER_THAN_FILLING_FAST_MIN]: i18n.t(
            'errorMessage.businessLogic.enterLowerNumberSubmissionFillingFast',
        ),
    },
    [SET_UP_ERRORS.SUBMISSION_STATUS_FULL_MIN]: {
        [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterNumberSlots'),
        [ERROR_CODES.SUBMISSION_STATUS_FULL_MIN_LOWER_THAN_FILLING_FAST_MIN]: i18n.t(
            'errorMessage.businessLogic.enterHigherNumberSubmissionFull',
        ),
    },
    registration_max_slots: {
        [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterNumberSlots'),
        [ERROR_CODES.REGISTRATION_MAX_SLOTS_LOWER_THAN_USED]: i18n.t(
            'errorMessage.registrationSlots.exceedApprovedUsers',
        ),
    },
    [SET_UP_ERRORS.SLOT_NUMBER]: {
        [ERROR_CODES.INPUT_REQUIRED]: i18n.t('errorMessage.validation.enterCampaignSlots'),
        [ERROR_CODES.SLOT_NUMBER_LESS_THAN_ONE]: i18n.t('errorMessage.validation.enterNumberGreaterThanOne'),
    },
}
